export const ACTION_SMART_BANNER_LOADED = 'HH-SmartBanner-Loaded';
export const ACTION_SMART_BANNER_HIDE = 'HH-SmartBanner-Hide';
